import { render } from "./NavbarProfile.vue?vue&type=template&id=ebe42552&scoped=true"
import script from "./NavbarProfile.vue?vue&type=script&lang=js"
export * from "./NavbarProfile.vue?vue&type=script&lang=js"

import "./NavbarProfile.vue?vue&type=style&index=0&id=ebe42552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe42552"]])

export default __exports__